module.exports = __webpack_public_path__ + "img/ic-carry.022a1b1.svg";